import React from 'react';
import './ProjectsHeading.css';

function ProjectsHeading() {
  return <div className='projects-heading'>PROJECTS</div>;
}

export default ProjectsHeading;
